<ziro-self-serve-top-bar></ziro-self-serve-top-bar>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

<div [hidden]="isLoading">
  <ziro-self-serve-user-details-back
    [link]="'/self-serve/user/' + user?.ref.username"
  ></ziro-self-serve-user-details-back>

  <ziro-self-serve-user-details-header
    [heading]="'tkey;self_serve.snr.header' | translate"
    [headingDataAutomation]="'self-serve-user-details-snr-header'"
  ></ziro-self-serve-user-details-header>

  <ziro-text [fieldId]="'destinationNumber'"></ziro-text>
  <ziro-text [fieldId]="'delay'"></ziro-text>

  <div class="col-sm-12 text-end">
    @if (snrDestination.id) {
      <ziro-button
        [cssClass]="'me-1'"
        [dataAutomation]="'snr-edit-delete'"
        [label]="'tkey;snr.snrdestination.delete.label' | translate"
        [icon]="ziroIcons.DELETE_SMALL"
        [iconPending]="ziroIcons.SAVING"
        [isPending]="isDeleting"
        [isDisabled]="isSubmitting"
        [buttonStyle]="buttonStyles.OUTLINE_DANGER"
        (clicked)="onDeleteClicked()"
      ></ziro-button>
    }
    <ziro-submit-button
      [isPending]="isSubmitting"
      [isDisabled]="isSubmitting"
      [cssClass]="'me-1'"
      [label]="'tkey;selfserve.user.single_number_reach.button.label'"
      [dataAutomation]="'self-serve-snr-edit-submit-button'"
      [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
      [iconPending]="ziroIcons.SAVING"
      [formSubmitSubject]="_validateAndSubmitSource"
    ></ziro-submit-button>
  </div>
</div>
